<template>
  <GmbRow align-y-content-center>
    <template #picto>
      <slot/>
    </template>

    <template #pictoTooltip>
      <slot name="pictoTooltip"/>
    </template>

    <FdText
        bold
        colorTheme3
        :fontSizeBigger5="!isSecondary"
        :fontSizeBigger4="isSecondary"
        :tag="isSecondary ? 'h2' : 'h1'"
        :uppercase="isSecondary"
    >{{ text }}
      &nbsp;&nbsp;
         <b-button
            v-if="enableDescriptionDisplay"
            id="fd-entity-description-launcher"
            class="d-flex p-1 justify-content-center align-items-center rounded-1"
            style="float: right"
            variant="primary"
         @click="openModal('entity-description-display')"
        >
          <FdText fa><i class="fas fa-info-circle"/></FdText>
          <FdText class="mx-2" tag="span">Infos</FdText>
        </b-button>

    </FdText
    >

  </GmbRow>
</template>

<script>
import FdText from "@/flexdesign/Text";

import GmbRow from "@/widgets/Row";
import ModalEventBus from "@/modalEventBus.js";

export default {
  name: "GmbDisplayHeading",

  components: {
    FdText,
    GmbRow,
  },

  props: {
    isSecondary: Boolean,
    text: String,
    enableDescriptionDisplay: Boolean,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
  openModal(modalSlug) {
    ModalEventBus.$emit("gmb-open-modal", modalSlug);
  },
  },
};
</script>

<style lang="scss">
@import "@/sass/settings/colors";

/* =========================================================================
 * MAP ZOOM CONTROLS BOX
 * ========================================================================= */

#fd-entity-description-launcher {
  color: $gmb-color-grey-1;
}

</style>
